export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-megaphone-f8fea7e3a04e85843f4613de8481f8db.svg";